"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var QuizBasic = function QuizBasic(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11C7.23871 11 5 8.76128 5 6V5C5 2.23871 7.23871 0 10 0C12.7613 0 15 2.23871 15 5V6C15 8.76128 12.7613 11 10 11ZM9.99999 9C11.6567 9 13 7.65671 13 6V5C13 3.34328 11.6567 2 9.99999 2C8.34328 2 6.99999 3.34328 6.99999 5V6C6.99999 7.65671 8.34328 9 9.99999 9ZM17 23H3C1.34372 23 0 21.6563 0 20V19C0 15.686 2.6864 13 6 13H14C17.3136 13 20 15.686 20 19V20C20 21.6563 18.6563 23 17 23ZM17 21C17.5517 21 18 20.5517 18 20V19C18 16.7907 16.2091 15 14 15H6C3.79091 15 2 16.7907 2 19V20C2 20.5517 2.44829 21 3 21H17Z",
    fill: color
  }));
};
var _default = QuizBasic;
exports.default = _default;